import type Paginated from 'app/core/paginable';
import httpApiApplication from 'app/http/httpApiApplication';

import type { CatalogValue } from './Catalog/catalogValue.model';
import { type CatalogTypeModel } from './CatalogType/types';
const baseUrl = 'catalogs';
const baseCatalogUrl = 'catalog-values';
class CatalogService {
  baseCatalogUrl() {
    return baseCatalogUrl;
  }
  baseCatalogTypeUrl(): string {
    return baseUrl;
  }
  CatalogTypesListPaging(
    page: number,
    pageSize: number,
    params: any = undefined
  ): Promise<Paginated<CatalogTypeModel>> {
    return httpApiApplication.paginate<CatalogTypeModel>(baseUrl, page, pageSize, params);
  }
  CatalogTypesList(): Promise<Array<CatalogTypeModel>> {
    return httpApiApplication.get(baseUrl + '/all');
  }
  catalogList(type?: string): Promise<Array<CatalogValue>> {
    return httpApiApplication.get(baseCatalogUrl + '/' + type);
  }
  catalogType(id?: string): Promise<CatalogTypeModel> {
    return httpApiApplication.get(baseUrl + '/' + id);
  }
  catalogTypeById(id?: string): Promise<CatalogTypeModel> {
    return httpApiApplication.get(baseUrl + '/id/' + id);
  }
  langList(): Promise<Array<string>> {
    return httpApiApplication.get(baseCatalogUrl + '/langs');
  }
  CreateCatalogType(values?: CatalogTypeModel) {
    return httpApiApplication
      .post(baseUrl, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
  UpdateCatalogType(values: CatalogTypeModel, id?: string) {
    return httpApiApplication
      .put(baseUrl + '/' + id, values)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
}
export default new CatalogService();
